import { TemplateCard } from "./TemplateCard"

// components/TemplatesMarquee.js
export const TemplatesMarquee = ({ templates }) => {
    return (
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-white z-10"></div>
        <div className="flex animate-marquee">
          {[...templates, ...templates].map((template, index) => (
            <TemplateCard key={index} template={template} />
          ))}
        </div>
      </section>
    )
  }
  